/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { SOLD_ASSETS } from "../pages/SoldAssets/graphql/sold-assets.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { TEST_DATA} from "./config/assets-test-data"

const MODULE_NAME = "SoldAssetsService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class SoldAssetsService {
    private static instance: SoldAssetsService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): SoldAssetsService {
        if (!SoldAssetsService.instance) {
            SoldAssetsService.instance = new SoldAssetsService(props);
        }
        return SoldAssetsService.instance;
    }

    async getSoldAssets(size: number, offset: number) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: SOLD_ASSETS,
                    variables: {
                        getAssetsSize: size,
                        getAssetsOffset: offset,
                        getAssetsCriteria: {
                            state: "sold"
                        }
                    },
                });
                log.success(MODULE_NAME, "getSoldAssets: ", res);
                return res?.data?.getAssets;
            }
        } catch (err) {
            log.error(MODULE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }

    // async getAssets(size: number, offset: number) {
    //     let _found = TEST_DATA;
    //    _found = _found.slice(offset, offset + size);
    //    return {
    //        pagination: {
    //            nextOffset: offset + _found.length,
    //            totalItems: TEST_DATA?.length,  
    //        },
    //        results: _found,
    //    }
    // }
    async getAssets(size: number, offset: number) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: SOLD_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state:"sold"
                          }
                    },
                    fetchPolicy:'network-only'
                });
                log.success(MODULE_NAME, "get assets result: ", res);
                // return res?.data?.getAssets;
                return {
            pagination: {
                nextOffset: offset + res?.data?.getAssets?.pageSize,
                totalItems: res?.data?.getAssets?.length,  
            },
            results: res?.data?.getAssets?.data,
        }
            }
        } catch (err) {
            log.error(MODULE_NAME, "error in get assets", err);
            // throw Error(`${err?.message}`)
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }
}
